<template>
  <v-navigation-drawer
    expand-on-hover
    rail
    left
    app
    permanent
    :mini-variant.sync="mini"
  >
    <template v-slot:prepend>
      <v-list class="py-0" dense nav>
        <v-list-item two-line class="px-0">
          <v-list-item-avatar>
            <v-icon>mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title mt-2 pb-2"
              >Orders Union</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-divider> </v-divider>

        <v-list-item to="/orders" link>
          <v-list-item-icon>
            <v-icon>mdi-cart</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Orders</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/products" link>
          <v-list-item-icon>
            <v-icon>mdi-storefront</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Products</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/customers" link>
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Customers</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/riders" link>
          <v-list-item-icon>
            <v-icon>mdi-moped</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Riders</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/reviews" link>
          <v-list-item-icon>
            <v-icon>mdi-comment-quote</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Reviews</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/messages" link>
          <v-list-item-icon>
            <v-icon>mdi-whatsapp</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Messages</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
/* eslint-disable */
export default {
  name: "SideNav",
  data: () => ({
    mini: true,
  }),
};
</script>

<style scoped>
</style>
